import SearchBarComponent from './SearchBarComponent'

export default SearchBarComponent
